const SuppliersScreen = () => {

    return(
        <p>Suppliers Screen</p>
    )
}

export default SuppliersScreen